/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BadRequest,
  DeleteGmsBatch200Response,
  InternalServerError,
  ServiceUnavailable,
  Unauthorized,
  UnprocessableEntity,
} from '../models/index';
import {
    BadRequestFromJSON,
    BadRequestToJSON,
    DeleteGmsBatch200ResponseFromJSON,
    DeleteGmsBatch200ResponseToJSON,
    InternalServerErrorFromJSON,
    InternalServerErrorToJSON,
    ServiceUnavailableFromJSON,
    ServiceUnavailableToJSON,
    UnauthorizedFromJSON,
    UnauthorizedToJSON,
    UnprocessableEntityFromJSON,
    UnprocessableEntityToJSON,
} from '../models/index';

export interface DeleteGmsBatchRequest {
    deleteBeforeDays: number;
    deleteRangeDays: number;
    executeAt: Date;
    forceOverwrite?: boolean;
}

/**
 * 
 */
export class BatchApi extends runtime.BaseAPI {

    /**
     * GMS削除バッチ
     */
    async deleteGmsBatchRaw(requestParameters: DeleteGmsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteGmsBatch200Response>> {
        if (requestParameters['deleteBeforeDays'] == null) {
            throw new runtime.RequiredError(
                'deleteBeforeDays',
                'Required parameter "deleteBeforeDays" was null or undefined when calling deleteGmsBatch().'
            );
        }

        if (requestParameters['deleteRangeDays'] == null) {
            throw new runtime.RequiredError(
                'deleteRangeDays',
                'Required parameter "deleteRangeDays" was null or undefined when calling deleteGmsBatch().'
            );
        }

        if (requestParameters['executeAt'] == null) {
            throw new runtime.RequiredError(
                'executeAt',
                'Required parameter "executeAt" was null or undefined when calling deleteGmsBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['deleteBeforeDays'] != null) {
            queryParameters['delete_before_days'] = requestParameters['deleteBeforeDays'];
        }

        if (requestParameters['deleteRangeDays'] != null) {
            queryParameters['delete_range_days'] = requestParameters['deleteRangeDays'];
        }

        if (requestParameters['executeAt'] != null) {
            queryParameters['execute_at'] = (requestParameters['executeAt'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['forceOverwrite'] != null) {
            queryParameters['force_overwrite'] = requestParameters['forceOverwrite'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/batch/gms`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteGmsBatch200ResponseFromJSON(jsonValue));
    }

    /**
     * GMS削除バッチ
     */
    async deleteGmsBatch(requestParameters: DeleteGmsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteGmsBatch200Response> {
        const response = await this.deleteGmsBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
